// extracted by mini-css-extract-plugin
export default {"root":"Skeleton__root___VDBIu","shimmer":"Skeleton__shimmer___zoXGV"};